import type { ReactNode } from "react";

export function V10Btn({
  children,
  variant = "default",
  disabled,
  onClick,
  type = "button",
  testId,
}: {
  readonly children: ReactNode;
  readonly variant?: "default" | "primary" | "gold" | "line";
  readonly disabled?: boolean;
  readonly onClick?: () => void;
  readonly type?: "button" | "submit";
  readonly testId?: string;
}) {
  return (
    <button
      type={type}
      className={`v10-btn${variant !== "default" ? ` v10-btn--${variant}` : ""}`}
      disabled={disabled}
      onClick={onClick}
      data-testid={testId}
    >
      {children}
    </button>
  );
}

export function V10Pill({ children, tone = "default" }: { readonly children: ReactNode; readonly tone?: "default" | "gold" | "green" }) {
  return <span className={`v10-pill${tone !== "default" ? ` v10-pill--${tone}` : ""}`}>{children}</span>;
}

export function V10Kicker({ children }: { readonly children: ReactNode }) {
  return <p className="v10-kicker">{children}</p>;
}
